import StaticModelApiService from "@/utils/Model/ApiService/StaticModelApiService";
import { Model } from "@vuex-orm/core";
import InstanceModelApiService from "@/utils/Model/ApiService/InstanceModelApiService";
import type { PrimaryKey } from "@vuex-orm/core/dist/src/query/options";

export default class BossModel extends Model {
    static entity: string;

    static apiUrl: string | null = null;

    static api() {
        return new StaticModelApiService(this);
    }

    api() {
        return new InstanceModelApiService(this);
    }

    async commit() {
        throw "replace Model.commit() with Model.insert()";
        // return this.constructor.insert(this);
    }

    Clone() {
        return Object.assign({}, this);
    }

    static get(params = {}) {
        console.log(params);

        throw "replace Model.get() with Model.api().get()";
    }

    Save() {
        throw "replace Model.Save() with Model.api().create()";
    }

    /**
     *
     */
    destroy() {
        throw "replace Model.destroy() with Model.api().delete()";
    }

    /**
     *
     * @param params
     * @returns {*}
     */
    static getAll(params = null) {
        console.log(params);

        throw "replace Model.getAll() with Model.all()";
    }

    getRelated(
        relationName: string,
        filter?: () => boolean,
    ): Model | Model[] | null {
        const relations: string[] = relationName.split(".");

        let data = (this.constructor as typeof Model)
            .query()
            .where(filter)
            .with(relationName)
            .find(this.$id as PrimaryKey);

        if (data === null) {
            return null;
        }

        relations.some((relationPart) => {
            if (data === null) {
                return true;
            }

            // @ts-expect-error Stop using getRelated
            if (!data[relationPart]) {
                data = null;
                return true;
            }
            // @ts-expect-error Stop using getRelated
            data = data[relationPart];
        });

        return data;
    }
}
